export default __webpack_public_path__ + "static/media/programaCard.db7ec19c.svg";